/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnFunctionalSkills
 */
export interface SourcingSearchFilterOnFunctionalSkills {
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchFilterOnFunctionalSkills
     */
    humanIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterOnFunctionalSkills
     */
    ratingTwoOrMoreRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilterOnFunctionalSkills
     */
    aggregation?: SourcingSearchFilterOnFunctionalSkillsAggregationEnum;
}


/**
 * @export
 */
export const SourcingSearchFilterOnFunctionalSkillsAggregationEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type SourcingSearchFilterOnFunctionalSkillsAggregationEnum = typeof SourcingSearchFilterOnFunctionalSkillsAggregationEnum[keyof typeof SourcingSearchFilterOnFunctionalSkillsAggregationEnum];


/**
 * Check if a given object implements the SourcingSearchFilterOnFunctionalSkills interface.
 */
export function instanceOfSourcingSearchFilterOnFunctionalSkills(value: object): value is SourcingSearchFilterOnFunctionalSkills {
    if (!('humanIds' in value) || value['humanIds'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnFunctionalSkillsFromJSON(json: any): SourcingSearchFilterOnFunctionalSkills {
    return SourcingSearchFilterOnFunctionalSkillsFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnFunctionalSkillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnFunctionalSkills {
    if (json == null) {
        return json;
    }
    return {
        
        'humanIds': json['humanIds'],
        'ratingTwoOrMoreRequired': json['ratingTwoOrMoreRequired'] == null ? undefined : json['ratingTwoOrMoreRequired'],
        'aggregation': json['aggregation'] == null ? undefined : json['aggregation'],
    };
}

export function SourcingSearchFilterOnFunctionalSkillsToJSON(value?: SourcingSearchFilterOnFunctionalSkills | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'humanIds': value['humanIds'],
        'ratingTwoOrMoreRequired': value['ratingTwoOrMoreRequired'],
        'aggregation': value['aggregation'],
    };
}

